<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <transition name="slide-fade">
      <div class="edit-page" v-show="web == 'edit' || web == 'add' || web == 'detail'">
        <div class="title">
          <span v-show="web === 'add'">新增</span>
          <span v-show="web === 'edit'">编辑</span>
          <span v-show="web === 'detail'">详细</span>
        </div>
        <div class="el-form" label-position="top">
          <el-form ref="addForm" :model="addForm" label-width="100px" :rules="rules" :disabled="web == 'detail'">
            <el-row>
              <el-col :xs="24" :sm="8">
                <el-form-item label="业务类型" prop="businessType">
                  <el-select
                    class="width-100"
                    size="small"
                    v-model="addForm.businessType"
                    placeholder="请选择"
                    @change="businessTypeChange"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.name"
                      v-for="(item, index) in businessTypes"
                      :key="'1-' + index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="截止日期" prop="deadline">
                  <el-date-picker
                    size="small"
                    v-model="addForm.deadline"
                    type="date"
                    value-format="yyyy-MM-dd 00:00:00"
                    :disabled="deadlineDisabled"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" v-permissions="'case:charge'">
                <el-form-item label="">
                  <el-button v-show="addForm.id" type="success" size="small" @click="addPay">收款登记</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="8">
                <el-form-item label="客户经理" prop="customerManagerId">
                  <el-select
                    class="width-100"
                    size="small"
                    v-model="addForm.customerManagerId"
                    placeholder="请选择"
                    @change="customerManagerChange"
                  >
                    <el-option :label="item.name" :value="item.id" v-for="(item, index) in persons" :key="'4-' + index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="16" v-permissions="'case:queryAccountant'">
                <el-form-item label="负责人" prop="caseAccountant">
                  <el-select
                    size="small"
                    ref="caseAccountant"
                    class="width-100"
                    v-model="addForm.caseAccountant"
                    multiple
                    placeholder="请选择"
                    :disabled="
                      userInfo.permissions.indexOf('case:addAccountant') < 0 ||
                        userInfo.permissions.indexOf('case:deleteAccountant') < 0
                    "
                    @change="caseAccountantChange"
                  >
                    <el-option
                      v-show="
                        (userInfo.content_jurisdiction == 0 && userInfo.id === item.id) ||
                          userInfo.content_jurisdiction != 0
                      "
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, index) in persons"
                      :key="'6-' + index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-table :data="caseContacts" style="width: 100%;margin-bottom:8px">
                  <el-table-column label="案件联系人">
                    <template slot-scope="scope">
                      <el-input
                        type="text"
                        size="small"
                        v-show="scope.row.state === 'add'"
                        v-model="scope.row.name"
                        placeholder="请输入"
                      >
                      </el-input>
                      <span v-show="scope.row.state !== 'add'">{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="联系方式">
                    <template slot-scope="scope">
                      <el-input
                        type="text"
                        size="small"
                        v-show="scope.row.state === 'add'"
                        v-model="scope.row.phone"
                        placeholder="请输入"
                      >
                      </el-input>
                      <span v-show="scope.row.state !== 'add'">{{ scope.row.phone }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="180px">
                    <template slot="header">
                      操作 <el-button type="success" size="mini" @click="addContact">新增案件联系人</el-button>
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        v-show="scope.row.state === 'add'"
                        size="mini"
                        plain
                        type="success"
                        @click="caseContactFormSave(scope.$index, scope.row)"
                        >保存
                      </el-button>
                      <el-button size="mini" plain type="danger" @click="delContact(scope.$index, scope.row)"
                        >删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="公司名称" prop="companyName">
                  <el-select
                    class="width-100"
                    size="small"
                    v-if="addForm.businessTypeCode !== '1'"
                    v-model="addForm.companyName"
                    placeholder="请选择"
                    filterable
                  >
                    <el-option
                      :label="item.name"
                      :value="item.name"
                      v-for="(item, index) in customers"
                      :key="'2-' + index"
                    >
                    </el-option>
                  </el-select>
                  <el-input
                    type="text"
                    size="small"
                    v-model="addForm.companyName"
                    placeholder="不在选择项的，请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="公司备用名称" prop="progress">
                  <el-input size="small" type="textarea" v-model="addForm.companyName1" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="" label-width="20px">
                  <div class="text-warning">*请填写3~5个，2字名称近似度高</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="24" v-if="addForm.businessTypeCode === '4'">
                <el-form-item label="项目名称" prop="qualification">
                  <el-input type="text" size="small" v-model="addForm.qualification" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="纳税性质" prop="taxNature">
                  <el-select class="width-100" size="small" v-model="addForm.taxNature" placeholder="请选择">
                    <el-option :label="item.name" :value="item.name" v-for="(item, index) in taxs" :key="'3-' + index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item type="text" label="注册资金" prop="registeredCapital">
                  <el-input
                    size="small"
                    type="number"
                    :min="0"
                    v-model="addForm.registeredCapital"
                    placeholder="请输入"
                  >
                    <template slot="append">万元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="是否代账" prop="isBookkeeping">
                  <el-radio-group v-model="addForm.isBookkeeping">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="8">
                <el-form-item label="法人" prop="legalPerson">
                  <el-input type="text" size="small" v-model="addForm.legalPerson" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8">
                <el-form-item label="法人身份证头像面" prop="legalPersonIdcardHead" label-width="180px">
                  <el-image
                    v-show="addForm.legalPersonIdcardHead"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.legalPersonIdcardHead"
                    :preview-src-list="[addForm.legalPersonIdcardHead]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.legalPersonIdcardHead, mask: addForm.legalPersonIdcardHead }">
                      <div v-show="!addForm.legalPersonIdcardHead"></div>
                      <div class="text" v-show="addForm.legalPersonIdcardHead">重新上传</div>
                      <input
                        type="file"
                        name="legalPersonIdcardHead"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.legalPersonIdcardHead,
                          'mask-file': addForm.legalPersonIdcardHead
                        }"
                        ref="legalPersonIdcardHead"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.legalPersonIdcardHead"
                    class="text-primary"
                    @click="downloadIamge(addForm.legalPersonIdcardHead, '法人身份证头像面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8">
                <el-form-item label="法人身份证国徽面" prop="legalPersonIdcardEmblem" label-width="180px">
                  <el-image
                    v-show="addForm.legalPersonIdcardEmblem"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.legalPersonIdcardEmblem"
                    :preview-src-list="[addForm.legalPersonIdcardEmblem]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.legalPersonIdcardEmblem, mask: addForm.legalPersonIdcardEmblem }">
                      <div v-show="!addForm.legalPersonIdcardEmblem"></div>
                      <div class="text" v-show="addForm.legalPersonIdcardEmblem">重新上传</div>
                      <input
                        type="file"
                        name="legalPersonIdcardEmblem"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.legalPersonIdcardEmblem,
                          'mask-file': addForm.legalPersonIdcardEmblem
                        }"
                        ref="legalPersonIdcardEmblem"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.legalPersonIdcardEmblem"
                    class="text-primary"
                    @click="downloadIamge(addForm.legalPersonIdcardEmblem, '法人身份证国徽面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="8">
                <el-form-item label="监事" prop="supervisor">
                  <el-input type="text" size="small" v-model="addForm.supervisor" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8">
                <el-form-item label="监事身份证头像面" prop="supervisorIdcardHead" label-width="180px">
                  <el-image
                    v-show="addForm.supervisorIdcardHead"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.supervisorIdcardHead"
                    :preview-src-list="[addForm.supervisorIdcardHead]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.supervisorIdcardHead, mask: addForm.supervisorIdcardHead }">
                      <div v-show="!addForm.supervisorIdcardHead"></div>
                      <div class="text" v-show="addForm.supervisorIdcardHead">重新上传</div>
                      <input
                        type="file"
                        name="supervisorIdcardHead"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.supervisorIdcardHead,
                          'mask-file': addForm.supervisorIdcardHead
                        }"
                        ref="supervisorIdcardHead"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.supervisorIdcardHead"
                    class="text-primary"
                    @click="downloadIamge(addForm.supervisorIdcardHead, '监事身份证头像面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8">
                <el-form-item label="监事身份证国徽面" prop="supervisorIdcardEmblem" label-width="180px">
                  <el-image
                    v-show="addForm.supervisorIdcardEmblem"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.supervisorIdcardEmblem"
                    :preview-src-list="[addForm.supervisorIdcardEmblem]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.supervisorIdcardEmblem, mask: addForm.supervisorIdcardEmblem }">
                      <div v-show="!addForm.supervisorIdcardEmblem"></div>
                      <div class="text" v-show="addForm.supervisorIdcardEmblem">重新上传</div>
                      <input
                        type="file"
                        name="supervisorIdcardEmblem"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.supervisorIdcardEmblem,
                          'mask-file': addForm.supervisorIdcardEmblem
                        }"
                        ref="supervisorIdcardEmblem"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.supervisorIdcardEmblem"
                    class="text-primary"
                    @click="downloadIamge(addForm.supervisorIdcardEmblem, '监事身份证国徽面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="8">
                <el-form-item label="财务负责人" prop="treasurer">
                  <el-input type="text" size="small" v-model="addForm.treasurer" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8">
                <el-form-item label="财务负责人身份证头像面" prop="treasurerIdcardHead" label-width="180px">
                  <el-image
                    v-show="addForm.treasurerIdcardHead"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.treasurerIdcardHead"
                    :preview-src-list="[addForm.treasurerIdcardHead]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.treasurerIdcardHead, mask: addForm.treasurerIdcardHead }">
                      <div v-show="!addForm.treasurerIdcardHead"></div>
                      <div class="text" v-show="addForm.treasurerIdcardHead">重新上传</div>
                      <input
                        type="file"
                        name="treasurerIdcardHead"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.treasurerIdcardHead,
                          'mask-file': addForm.treasurerIdcardHead
                        }"
                        ref="treasurerIdcardHead"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.treasurerIdcardHead"
                    class="text-primary"
                    @click="downloadIamge(addForm.treasurerIdcardHead, '财务负责人身份证头像面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8">
                <el-form-item label="财务负责人身份证国徽面" prop="treasurerIdcardEmblem" label-width="180px">
                  <el-image
                    v-show="addForm.treasurerIdcardEmblem"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.treasurerIdcardEmblem"
                    :preview-src-list="[addForm.treasurerIdcardEmblem]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.treasurerIdcardEmblem, mask: addForm.treasurerIdcardEmblem }">
                      <div v-show="!addForm.treasurerIdcardEmblem"></div>
                      <div class="text" v-show="addForm.treasurerIdcardEmblem">重新上传</div>
                      <input
                        type="file"
                        name="treasurerIdcardEmblem"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.treasurerIdcardEmblem,
                          'mask-file': addForm.treasurerIdcardEmblem
                        }"
                        ref="treasurerIdcardEmblem"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.treasurerIdcardEmblem"
                    class="text-primary"
                    @click="downloadIamge(addForm.treasurerIdcardEmblem, '财务负责人身份证国徽面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col v-permissions="'case:queryShareholder'" :xs="24" :sm="24">
                <el-table
                  v-if="showState === 'pc'"
                  class="show-pc"
                  :data="caseShareholders"
                  style="width: 100%;margin-bottom:8px"
                  @selection-change="shareholderSelectionChange"
                >
                  <el-table-column width="100">
                    <template slot="header">
                      <el-button type="primary" size="mini" @click="shareholderSelectionDownload">批量下载</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column type="selection" width="50"> </el-table-column>
                  <el-table-column label="股东">
                    <template slot-scope="scope">
                      <el-input
                        type="text"
                        v-show="scope.row.state === 'add'"
                        v-model="caseShareholderForm.name"
                        placeholder="请输入股东"
                      ></el-input>
                      <span v-show="scope.row.state !== 'add'">{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column class="show-pc" label="占股比例">
                    <template slot-scope="scope">
                      <el-input
                        type="number"
                        max="100"
                        min="0"
                        v-show="scope.row.state === 'add'"
                        v-model="caseShareholderForm.shareProportion"
                        placeholder="请输入占股比例"
                      >
                        <template slot="append">%</template>
                      </el-input>
                      <span v-show="scope.row.state !== 'add'">{{ scope.row.shareProportion }} %</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" label="国徽面">
                    <template slot-scope="scope">
                      <span v-show="scope.row.state !== 'add'">
                        <el-image
                          style="width: 100px;vertical-align: middle; height: auto"
                          :src="scope.row.idcardEmblem"
                          :preview-src-list="[scope.row.idcardEmblem]"
                        >
                        </el-image>
                        <div
                          v-show="scope.row.idcardEmblem"
                          class="text-primary"
                          @click="downloadIamge(scope.row.idcardEmblem, '股东身份证国徽面-' + scope.row.name)"
                        >
                          图片下载
                        </div>
                      </span>
                      <span v-show="scope.row.state === 'add'" class="img-box">
                        <!-- 选择图片预览 -->
                        <img :src="caseShareholderForm.idcardEmblem" />
                        <!-- 选择按钮 -->
                        <div
                          :class="{ upload: !caseShareholderForm.idcardEmblem, mask: caseShareholderForm.idcardEmblem }"
                        >
                          <div v-show="!caseShareholderForm.idcardEmblem"></div>
                          <div class="text" v-show="caseShareholderForm.idcardEmblem">重新上传</div>
                          <input
                            type="file"
                            name="idcardEmblem"
                            accept="image/*"
                            :class="{
                              'upload-file': !caseShareholderForm.idcardEmblem,
                              'mask-file': caseShareholderForm.idcardEmblem
                            }"
                            ref="idcardEmblem"
                            @change="picReadUpload($event, 'caseShareholderForm')"
                          />
                        </div>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" label="头像面">
                    <template slot-scope="scope">
                      <span v-show="scope.row.state !== 'add'">
                        <el-image
                          style="width: 100px;vertical-align: middle; height: auto"
                          :src="scope.row.idcardHead"
                          :preview-src-list="[scope.row.idcardHead]"
                        >
                        </el-image>
                        <div
                          v-show="scope.row.idcardHead"
                          class="text-primary"
                          @click="downloadIamge(scope.row.idcardHead, '股东身份证头像面-' + scope.row.name)"
                        >
                          图片下载
                        </div>
                      </span>
                      <span v-show="scope.row.state === 'add'" class="img-box">
                        <!-- 选择图片预览 -->
                        <img :src="caseShareholderForm.idcardHead" />
                        <!-- 选择按钮 -->
                        <div :class="{ upload: !caseShareholderForm.idcardHead, mask: caseShareholderForm.idcardHead }">
                          <div v-show="!caseShareholderForm.idcardHead"></div>
                          <div class="text" v-show="caseShareholderForm.idcardHead">重新上传</div>
                          <input
                            type="file"
                            name="idcardHead"
                            accept="image/*"
                            :class="{
                              'upload-file': !caseShareholderForm.idcardHead,
                              'mask-file': caseShareholderForm.idcardHead
                            }"
                            ref="idcardHead"
                            @change="picReadUpload($event, 'caseShareholderForm')"
                          />
                        </div>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="180px" label="">
                    <template slot="header">
                      操作
                      <el-button
                        v-permissions="'case:addShareholder'"
                        type="success"
                        size="small"
                        @click="addCaseShareholder"
                        >新增股东</el-button
                      >
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        v-show="scope.row.state === 'add'"
                        type="primary"
                        size="mini"
                        class="save"
                        @click="caseShareholderFormSave(scope.$index, 'caseShareholderForm')"
                        >保存</el-button
                      >
                      <el-button
                        v-permissions="'case:deleteShareholder'"
                        size="mini"
                        plain
                        type="danger"
                        @click="delCaseShareholder(scope.$index, scope.row)"
                      >
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table
                  v-if="showState === 'phone'"
                  class="show-phone"
                  :data="caseShareholders"
                  style="width: 100%;margin-bottom:8px"
                  :span-method="spanMethod4"
                >
                  <el-table-column label="股东信息">
                    <template slot-scope="scope">
                      <div v-show="scope.row.state === 'add'">
                        <el-input
                          type="text"
                          size="small"
                          v-model="caseShareholderForm.name"
                          placeholder="请输入股东"
                        ></el-input>
                        <br />
                        <el-input
                          type="number"
                          :max="100"
                          :min="0"
                          v-model="caseShareholderForm.shareProportion"
                          placeholder="请输入占股比例"
                        >
                          <template slot="append">%</template>
                        </el-input>
                        <br />
                        <span>国徽面</span>
                        <!-- 选择图片预览 -->
                        <span v-show="scope.row.state === 'add'">
                          <el-image
                            v-show="caseShareholderForm.idcardEmblem"
                            style="width: 100px;vertical-align: middle; height: auto;margin-left:10px"
                            :src="caseShareholderForm.idcardEmblem"
                            :preview-src-list="[caseShareholderForm.idcardEmblem]"
                          >
                          </el-image>
                        </span>
                        <span class="img-box">
                          <!-- 选择按钮 -->
                          <div
                            :class="{
                              upload: !caseShareholderForm.idcardEmblem,
                              mask: caseShareholderForm.idcardEmblem
                            }"
                          >
                            <div v-show="!caseShareholderForm.idcardEmblem"></div>
                            <div class="text" v-show="caseShareholderForm.idcardEmblem">重新上传</div>
                            <input
                              type="file"
                              name="idcardEmblem"
                              accept="image/*"
                              :class="{
                                'upload-file': !caseShareholderForm.idcardEmblem,
                                'mask-file': caseShareholderForm.idcardEmblem
                              }"
                              ref="idcardEmblem"
                              @change="picReadUpload($event, 'caseShareholderForm')"
                            />
                          </div>
                        </span>
                        <br />
                        <span>头像面</span>
                        <!-- 选择图片预览 -->
                        <span v-show="scope.row.state === 'add'">
                          <el-image
                            v-show="caseShareholderForm.idcardHead"
                            style="width: 100px;vertical-align: middle; height: auto;margin-left:10px"
                            :src="caseShareholderForm.idcardHead"
                            :preview-src-list="[caseShareholderForm.idcardHead]"
                          >
                          </el-image>
                        </span>
                        <span class="img-box">
                          <!-- 选择图片预览 -->
                          <img :src="caseShareholderForm.idcardHead" />
                          <!-- 选择按钮 -->
                          <div
                            :class="{ upload: !caseShareholderForm.idcardHead, mask: caseShareholderForm.idcardHead }"
                          >
                            <div v-show="!caseShareholderForm.idcardHead"></div>
                            <div class="text" v-show="caseShareholderForm.idcardHead">重新上传</div>
                            <input
                              type="file"
                              name="idcardHead"
                              accept="image/*"
                              :class="{
                                'upload-file': !caseShareholderForm.idcardHead,
                                'mask-file': caseShareholderForm.idcardHead
                              }"
                              ref="idcardHead"
                              @change="picReadUpload($event, 'caseShareholderForm')"
                            />
                          </div>
                        </span>
                      </div>
                      <div v-show="scope.row.state !== 'add'">
                        <table style="border:0;width:100%">
                          <tr>
                            <td style="width:50%;border:0">股东：{{ scope.row.name }}</td>
                            <td style="width:50%;border:0">占股比例：{{ scope.row.shareProportion }} %</td>
                          </tr>
                          <tr>
                            <td style="width:50%;border:0">
                              <div>国徽面</div>
                              <el-image
                                style="width: 100px;vertical-align: middle; height: auto"
                                :src="scope.row.idcardEmblem"
                                :preview-src-list="[scope.row.idcardEmblem]"
                              >
                              </el-image>
                            </td>
                            <td style="width:50%;border:0">
                              <div>头像面</div>
                              <el-image
                                style="width: 100px;vertical-align: middle; height: auto"
                                :src="scope.row.idcardHead"
                                :preview-src-list="[scope.row.idcardHead]"
                              >
                              </el-image>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="50px" label=" "> </el-table-column>
                  <el-table-column width="50px" label=" "></el-table-column>
                  <el-table-column width="50px" label=" "></el-table-column>
                  <el-table-column width="100px" label="操作">
                    <template slot="header">
                      操作
                      <el-button
                        v-permissions="'case:addShareholder'"
                        type="success"
                        size="small"
                        @click="addCaseShareholder"
                        >新增股东</el-button
                      >
                    </template>
                    <template slot-scope="scope">
                      <div class="show-pc">
                        <el-button
                          v-show="scope.row.state === 'add'"
                          type="primary"
                          size="mini"
                          class="save"
                          @click="caseShareholderFormSave(scope.$index, 'caseShareholderForm')"
                          >保存</el-button
                        >
                        <el-button
                          v-permissions="'case:deleteShareholder'"
                          size="mini"
                          plain
                          type="danger"
                          @click="delCaseShareholder(scope.$index, scope.row)"
                        >
                          删除
                        </el-button>
                      </div>
                      <div class="show-phone">
                        <el-button
                          v-show="scope.row.state === 'add'"
                          type="primary"
                          size="small"
                          class="save"
                          @click="caseShareholderFormSave(scope.$index, 'caseShareholderForm')"
                          >保存</el-button
                        >
                        <br />
                        <br />
                        <el-button size="mini" plain type="danger" @click="delCaseShareholder(scope.$index, scope.row)">
                          删除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col
                v-permissions="'case:queryShareholder'"
                :xs="24"
                :sm="addForm.businessTypeCode === '1' || addForm.businessTypeCode === '2' ? 8 : 6"
              >
                <el-form-item class="show-pc" label="区域" prop="qy">
                  <el-cascader
                    size="small"
                    class="width-100"
                    v-model="addForm.qy"
                    placeholder="请选择区域"
                    :options="options"
                    filterable
                    @change="qyChange"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item class="show-phone" label="区域">
                  <div @click="popupShow">
                    <el-input size="small" v-model="addForm.qy2" :disabled="true"></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="16" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="注册地址" prop="address">
                  <el-input type="text" size="small" v-model="addForm.address" placeholder="注册地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="经营范围" prop="natureOfBusiness">
                  <el-input size="small" type="textarea" v-model="addForm.natureOfBusiness"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" v-if="addForm.businessTypeCode === '2'" v-permissions="'case:queryChange'">
                <el-form-item label="变更项" prop="caseChange">
                  <el-select
                    size="small"
                    ref="caseChange"
                    class="width-100"
                    v-model="addForm.caseChange"
                    multiple
                    :disabled="
                      userInfo.permissions.indexOf('case:addChange') < 0 &&
                        userInfo.permissions.indexOf('case:deleteChange') < 0
                    "
                    placeholder="请选择"
                    @change="caseChangeChange"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.name"
                      v-for="(item, index) in changes"
                      :key="'5-' + index"
                    >
                    </el-option>
                  </el-select>
                  <!-- <el-button type="success" size="small" @click="addCaseChange">新增变更项</el-button> -->
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="addForm.businessTypeCode === '1' || addForm.businessTypeCode === '2' ? 8 : 6">
                <el-form-item label="预付款" prop="advancePayment">
                  <el-input-number
                    size="mini"
                    v-model="addForm.advancePayment"
                    :min="0"
                    :step="0.01"
                    step-strictly
                    placeholder="请输入预付款"
                  ></el-input-number>
                  <span> 元</span>
                  <!-- <el-input  size="small" v-model="addForm.advancePayment" placeholder="请输入">
                    <template slot="append">元</template>
                  </el-input> -->
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="addForm.businessTypeCode === '1' || addForm.businessTypeCode === '2' ? 8 : 6">
                <el-form-item label="尾款" prop="finalPayment">
                  <el-input-number
                    size="mini"
                    v-model="addForm.finalPayment"
                    :min="0"
                    :step="0.01"
                    step-strictly
                    placeholder="请输入尾款"
                  ></el-input-number>
                  <span> 元</span>
                  <!-- <el-input  size="small" v-model="addForm.finalPayment" placeholder="请输入">
                    <template slot="append">元</template>
                  </el-input> -->
                </el-form-item>
              </el-col>
              <!-- <el-col :xs="24" :sm="8">
                <el-form-item label="案件类型" prop="caseType">
                  <el-select  size="small" v-model="addForm.caseType" placeholder="请选择">
                    <el-option :label="item.name" :value="item.name" v-for="(item, index) in caseTypes" :key="'6-'+index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col
                :xs="24"
                :sm="addForm.businessTypeCode === '1' || addForm.businessTypeCode === '2' ? 8 : 6"
                v-if="addForm.id"
              >
                <el-form-item label="状态" prop="state">
                  <el-select class="width-100" size="small" v-model="addForm.state" placeholder="请选择">
                    <el-option
                      :label="item.name"
                      :value="item.name"
                      v-for="(item, index) in states"
                      :key="'7-' + index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="备注" prop="remark">
                  <el-input size="small" type="textarea" v-model="addForm.remark"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" v-permissions="'case:queryProgress'">
                <el-table :data="progresss" style="width: 100%;margin-bottom:8px" :span-method="spanMethod">
                  <el-table-column label="进展内容">
                    <template slot-scope="scope">
                      <el-input
                        v-show="scope.row.state === 'add'"
                        type="textarea"
                        v-model="scope.row.content"
                        placeholder="请输入"
                      ></el-input>
                      <div v-show="scope.row.state !== 'add'" class="colspan">
                        <span>{{ scope.row.content }}</span>
                        <span>{{ scope.row.progressTime }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="保存时间"></el-table-column>
                  <el-table-column label="操作" width="150px">
                    <template slot="header">
                      操作
                      <el-button v-permissions="'case:addProgress'" type="success" size="mini" @click="addProgress"
                        >新增进展</el-button
                      >
                    </template>
                    <template slot-scope="scope">
                      <div v-show="scope.row.state !== 'add' && addForm.id">{{ scope.row.operator }}</div>
                      <el-button
                        v-show="scope.row.state === 'add'"
                        size="mini"
                        plain
                        type="success"
                        @click="progressFormSave(scope.$index, scope.row)"
                        >保存
                      </el-button>
                      <br v-show="scope.row.state === 'add'" />
                      <el-button
                        v-show="scope.row.state === 'add' || !addForm.id"
                        size="mini"
                        plain
                        type="danger"
                        @click="delProgress(scope.$index, scope.row)"
                        >删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 分页器 -->
                <div class="page show-pc">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, sizes, jumper"
                    :total="total"
                  >
                  </el-pagination>
                </div>
                <div class="page show-phone">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total"
                  >
                  </el-pagination>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" v-show="addForm.id">
                <el-form-item class="form-item-phone-inline" label="图片名称" prop="wj">
                  <el-row>
                    <el-col :xs="12" :sm="13">
                      <el-input type="text" size="small" v-model="addForm.picName" placeholder="请输入"></el-input>
                    </el-col>
                    <el-col :xs="10" :offset="2" :sm="9">
                      <span class="img-box">
                        <!-- 选择图片预览 -->
                        <img :src="picJdcmp.src" />
                        <!-- 选择按钮 -->
                        <div
                          class="el-button el-button--success el-button--small"
                          :class="{ 'upload-btn': !picJdcmp.src, mask: picJdcmp.src }"
                        >
                          <div class="text" v-show="picJdcmp.src">重新选择</div>
                          <div class="text" v-show="!picJdcmp.src">选择图片</div>
                          <input
                            type="file"
                            name="picJdcmp"
                            accept="image/*"
                            :class="{ 'upload-file': !picJdcmp.src, 'mask-file': picJdcmp.src }"
                            ref="picJdcmp"
                            @change="picRead"
                          />
                        </div>
                      </span>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" v-show="addForm.id">
                <el-table :data="pics" style="width: 100%;margin-bottom:8px" @selection-change="picSelectionChange">
                  <el-table-column width="100">
                    <template slot="header">
                      <el-button type="primary" size="mini" @click="picSelectionDownload">批量下载</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column type="selection" width="100"></el-table-column>
                  <el-table-column label="图片名称">
                    <template slot-scope="scope">
                      <span>{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="图片">
                    <template slot-scope="scope">
                      <span>
                        <el-image
                          style="width: 100px;vertical-align: middle; height: auto"
                          :src="scope.row.url"
                          :preview-src-list="[scope.row.url]"
                        >
                        </el-image>
                        <div
                          v-show="scope.row.url"
                          class="text-primary"
                          @click="downloadIamge(scope.row.url, scope.row.name)"
                        >
                          图片下载
                        </div>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" plain type="danger" @click="delPic(scope.row)">删除 </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :xs="24" :sm="12" v-show="addForm.id">
                <el-form-item class="form-item-phone-inline" label="文件名称" prop="wj">
                  <el-row>
                    <el-col :xs="12" :sm="13">
                      <el-input type="text" size="small" v-model="addForm.fileName" placeholder="请输入"></el-input>
                    </el-col>
                    <el-col :xs="10" :offset="2" :sm="9">
                      <span class="img-box">
                        <!-- 选择按钮 -->
                        <div class="el-button el-button--success el-button--small upload-btn">
                          <div class="text" v-show="picJdcmp.src">重新选择</div>
                          <div class="text" v-show="!picJdcmp.src">选择文件</div>
                          <input
                            type="file"
                            name="picJdcmp2"
                            accept="*"
                            class="upload-file"
                            ref="picJdcmp2"
                            @change="fileRead"
                          />
                        </div>
                      </span>
                      <p class="text-primary" v-show="picJdcmp2.src">选择文件名称：{{ picJdcmp2.src }}</p>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" v-show="addForm.id">
                <el-table :data="files" style="width: 100%;margin-bottom:8px" @selection-change="fileSelectionChange">
                  <el-table-column width="100">
                    <template slot="header">
                      <el-button type="primary" size="mini" @click="fileSelectionDownload">批量下载</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column type="selection" width="100"></el-table-column>
                  <el-table-column label="文件名称">
                    <template slot-scope="scope">
                      <span>{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="文件">
                    <template slot-scope="scope">
                      <span>
                        <a :href="scope.row.url" target="_blank" :download="scope.row.name">下载</a>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" plain type="danger" @click="delFile(scope.row)">删除 </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin: 10px" class="btn">
            <el-button
              v-show="!addForm.id"
              v-permissions="'case:add'"
              type="primary"
              size="small"
              class="save"
              @click="addSave('addForm')"
              >保存
            </el-button>
            <el-button
              v-show="addForm.id && web != 'detail'"
              v-permissions="'case:update'"
              type="primary"
              size="small"
              class="save"
              @click="editSave('addForm')"
              >保存
            </el-button>
            <el-button
              v-show="addForm.id && web != 'detail'"
              v-permissions="'case:caseToCustomer'"
              type="warning"
              size="small"
              class="save"
              @click="caseToCustomer"
              >一键转客户
            </el-button>
            <el-button type="primary" size="small" plain class="cancel" @click="cancel">返回</el-button>
          </div>
        </div>
      </div>
    </transition>

    <van-popup v-model="popupShowState" position="bottom" :style="{ height: '' }" :lazy-render="false">
      <van-picker
        ref="picker2"
        show-toolbar
        title="区域"
        :columns="options"
        cancel-button-text="清空"
        @confirm="pickerConfirm"
        @cancel="pickerCancel"
      />
    </van-popup>
    <el-drawer size="300px" :with-header="false" :visible.sync="drawer">
      <div class="drawer-box">
        <el-form
          ref="payRecord"
          :label-position="'top'"
          :model="payRecord"
          label-width="100px"
          :rules="rules4"
          :disabled="web == 'detail'"
        >
          <div class="title" style="padding:8px">收款登记</div>
          <el-row>
            <el-col :xs="24" :sm="24">
              <el-form-item label="客户名称" prop="customerName">
                <el-input
                  type="text"
                  size="small"
                  :disabled="true"
                  v-model="payRecord.customerName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="收款项目" prop="payProject">
                <el-input type="text" size="small" v-model="payRecord.payProject" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="金额" prop="amount">
                <el-input-number
                  v-model="payRecord.amount"
                  :min="0"
                  :step="0.01"
                  step-strictly
                  placeholder="请输入金额"
                ></el-input-number>
                <span slot="append">元</span>
                <!-- <el-input  size="small" type="number" min="0" v-model="payRecord.amount" placeholder="请输入">
                <template slot="append">元</template>
              </el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="折扣" prop="discount">
                <el-input-number
                  v-model="payRecord.discount"
                  :min="0.1"
                  :max="10"
                  :step="0.1"
                  step-strictly
                  placeholder="请输入金额"
                ></el-input-number>
                <span slot="append">折</span>
                <!-- <el-input  size="small" type="number" min="0" max="9.99" v-model="payRecord.discount" placeholder="请输入">
                <template slot="append">折</template>
              </el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="实收金额" prop="realAmount">
                <el-input-number
                  v-model="payRecord.realAmount"
                  :min="0"
                  :step="0.01"
                  step-strictly
                  placeholder="请输入金额"
                ></el-input-number>
                <span slot="append">元</span>
                <!-- <el-input  size="small" type="number" min="0" v-model="payRecord.realAmount" placeholder="请输入">
                <template slot="append">元</template>
              </el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="尾款" prop="finalPayment">
                <el-input-number
                  v-model="payRecord.finalPayment"
                  :min="0"
                  :step="0.01"
                  step-strictly
                  placeholder="请输入金额"
                ></el-input-number>
                <span slot="append">元</span>
                <!-- <el-input  size="small" type="number" min="0" v-model="payRecord.finalPayment" placeholder="请输入">
                <template slot="append">元</template>
              </el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="收款经办人">
                <el-input type="text" size="small" :value="userInfo.name" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item class="show-pc" label="合同时间" prop="payTime">
                <el-date-picker
                  size="small"
                  v-model="payRecord.payTime"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="show-phone" label="开始日期">
                <el-date-picker
                  size="small"
                  v-model="payRecord.payPeriodStart"
                  type="date"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  @change="payPeriodStartChange"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="show-phone" label="结束日期">
                <el-date-picker
                  size="small"
                  v-model="payRecord.payPeriodEnd"
                  type="date"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  @change="payPeriodEndChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="备注" prop="remark">
                <el-input size="small" type="textarea" v-model="payRecord.remark" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item>
                <el-button type="primary" size="small" class="save" @click="addPaySave('payRecord')">保存 </el-button>
                <el-button type="primary" plain size="small" class="save" @click="drawer = false">返回</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import cityData from '../../../utils/Data'
export default {
  name: 'Detail',
  data() {
    return {
      userInfo: {},
      titles: ['案件中心'],
      web: '',
      showState: '',
      addForm: {
        address: '',
        companyName: '', // 公司名称
        companyName1: '', // 公司名称
        projectName: '', // 项目名称
        businessType: '', // 业务类型
        taxNature: '', // 纳税性质
        registeredCapital: '', // 注册资金
        legalPerson: '', // 法人
        legalPersonIdcardEmblem: '', // 法人身份证国徽面
        legalPersonIdcardHead: '', // 法人身份证头像面
        supervisor: '', // 监事
        supervisorIdcardEmblem: '', // 监事身份证国徽面
        supervisorIdcardHead: '', // 监事身份证头像面
        treasurer: '', // 财务负责人
        treasurerIdcardEmblem: '', // 财务负责人身份证国徽面
        treasurerIdcardHead: '', // 财务负责人身份证头像面
        natureOfBusiness: '', // 经营范围
        isBookkeeping: '', // 是否代账
        customerManagerId: '', // 客户经理
        customerManagerName: '', // 客户经理
        caseAccountant: [], // 负责人
        advancePayment: '', // 预付款
        caseType: '', // 案件类型
        state: '', // 状态
        finalPayment: '', // 尾款
        remark: '', // 备注
        picJdcmp: '',
        picJdcmp2: '',
        caseChange: [],
        qualification: '', // 项目名称
        qy: '', // 区域
        qy2: '', // 区域
        deadline: '' // 截止日期
      },
      businessTypes: [],
      taxs: [
        { roleId: '小规模', remark: '小规模' },
        { roleId: '一般纳税人', remark: '一般纳税人' }
      ],
      states: [
        { roleId: '在办', remark: '在办' },
        { roleId: '办结', remark: '办结' }
      ],
      customers: [], // 公司客户数组
      caseTypes: [],
      picJdcmp: { src: '', file: '', name: '图片' },
      picJdcmp2: { src: '', file: '', name: '文件' },
      pics: [],
      files: [],
      persons: [], // 公司所有用户
      caseAccountants: [], // 负责人
      caseContacts: [], // 案件联系人
      caseContactForm: {
        name: '',
        phone: ''
      }, // 案件联系人表单
      caseShareholders: [], // 股东数组
      caseShareholderForm: {
        name: '',
        shareProportion: '',
        idcardEmblem: '', // 股东身份证国徽面
        idcardHead: ''
      }, // 股东表单
      caseChanges: [], // 变更项数组
      caseChangeForm: {
        name: ''
      }, // 变更项表单
      changes: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      progresss: [], // 进展数组
      progressForm: {
        content: '',
        operator: ''
      }, // 进展表单
      supervisorForm: {
        supervisor: '', // 监事
        supervisorIdcardEmblem: '', // 监事身份证国徽面
        supervisorIdcardHead: '' // 监事身份证头像面
      },
      treasurerForm: {
        treasurer: '', // 财务负责人
        treasurerIdcardEmblem: '', // 财务负责人身份证国徽面
        treasurerIdcardHead: '' // 财务负责人身份证头像面
      },
      legalPersonForm: {
        legalPerson: '', // 法人
        legalPersonIdcardEmblem: '', // 法人身份证国徽面
        legalPersonIdcardHead: '' // 法人身份证头像面
      },
      options: cityData,
      popupShowState: false,
      shareholderSelection: [],
      picSelection: [],
      fileSelection: [],
      drawer: false,
      payRecord: {
        customerName: '', // 客户名称
        payProject: '', // 收费项目名称
        amount: '', // 总金额
        realAmount: '', // 实收金额
        discount: 10, // 折扣
        finalPayment: '', // 尾款
        payPeriodStart: '', // 计费周期始
        payPeriodEnd: '', // 计费周期止
        payTime: [],
        remark: ''
      },
      deadlineDisabled: false,
      rules: {
        businessType: [{ type: 'string', required: true, message: '请输入业务类型', trigger: 'blur' }]
        // companyName: [{ type: 'any', message: '请输入公司名称', trigger: 'blur' }],
        // taxNature: [{ type: 'any', message: '请选择纳税性质', trigger: 'change' }],
        // registeredCapital: [{ type: 'any', message: '请输入注册资金', trigger: 'blur' }],
        // legalPerson: [{ type: 'any', message: '请输入法人', trigger: 'blur' }],
        // supervisor: [{ type: 'any', message: '请输入监事', trigger: 'blur' }],
        // treasurer: [{ type: 'any', message: '请输入财务负责人', trigger: 'blur' }],
        // natureOfBusiness: [{ message: '请输入经营范围', trigger: 'blur' }],
        // qy: [{ type: 'any', message: '请选择区域', trigger: 'blur' }],
        // address: [{ type: 'any', message: '请输入注册地址 ', trigger: 'blur' }],
        // isBookkeeping: [{ type: 'any', message: '请选择是否代账', trigger: 'change' }],
        // customerManagerId: [{ type: 'any', message: '请选择客户经理', trigger: 'change' }],
        // caseAccountant: [{ type: 'any', message: '请选择负责人', trigger: 'change' }],
        // advancePayment: [{ type: 'any', message: '请输入预付款', trigger: 'blur' }],
        // caseType: [{ type: 'any', message: '请选择案件类型', trigger: 'change' }],
        // state: [{ type: 'any', message: '请选择状态', trigger: 'change' }],
        // finalPayment: [{ type: 'any', message: '请输入尾款', trigger: 'blur' }],
        // caseChange: [{ type: 'any', message: '请选择变更项', trigger: 'change' }],
        // remark: [{ type: 'any', message: '请输入备注', trigger: 'blur' }]
      },
      rules2: {
        name: [{ required: true, message: '请输入案件联系人姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入案件联系人手机号', trigger: 'blur' }]
      },
      rules3: {
        name: [{ required: true, message: '请输入股东姓名', trigger: 'blur' }],
        shareProportion: [{ required: true, message: '请输入占股比例', trigger: 'blur' }]
      },
      rules4: {
        name: [{ required: true, message: '请输入变更项', trigger: 'blur' }]
      },
      rules5: {
        supervisor: [{ required: true, message: '请输入监事', trigger: 'blur' }],
        supervisorIdcardEmblem: [{ required: true, message: '请选择监事身份证国徽面', trigger: 'blur' }],
        supervisorIdcardHead: [{ required: true, message: '请选择监事身份证头像面', trigger: 'blur' }]
      },
      rules6: {
        treasurer: [{ required: true, message: '请输入财务负责人', trigger: 'blur' }],
        treasurerIdcardEmblem: [{ required: true, message: '请选择财务负责人身份证国徽面', trigger: 'blur' }],
        treasurerIdcardHead: [{ required: true, message: '请选择财务负责人身份证头像面', trigger: 'blur' }]
      },
      rules7: {
        legalPerson: [{ required: true, message: '请输入法人', trigger: 'blur' }],
        legalPersonIdcardEmblem: [{ required: true, message: '请选择法人身份证国徽面', trigger: 'blur' }],
        legalPersonIdcardHead: [{ required: true, message: '请选择法人身份证头像面', trigger: 'blur' }]
      },
      rules8: {
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      rules9: {
        customerName: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        payProject: [{ required: true, message: '请输入收费项目名称', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入总金额', trigger: 'blur' }],
        realAmount: [{ required: true, message: '请输入收费金额', trigger: 'blur' }],
        discount: [{ required: true, message: '请输入折扣', trigger: 'blur' }],
        finalPayment: [{ required: true, message: '请输入尾款', trigger: 'blur' }]
      }
    }
  },
  methods: {
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return [1, 2]
      } else if (columnIndex === 1) {
        return [0, 0]
      }
    },
    spanMethod4({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return [1, 4]
      } else if (columnIndex === 1) {
        return [0, 0]
      } else if (columnIndex === 2) {
        return [0, 0]
      } else if (columnIndex === 3) {
        return [0, 0]
      }
    },
    reset() {},
    // 查询详情
    queryDetail() {
      const param = {
        id: this.$route.params.id
      }
      this.$get('/case/detail', param).then(
        result => {
          if (result.status === 200) {
            this.detailInfo = result.data
            for (const i in this.detailInfo) {
              this.addForm[i] = this.detailInfo[i]
            }
            if (!this.addForm.customerManagerId || !this.addForm.customerManagerName) {
              this.addForm.customerManagerId = this.userInfo.id
              this.addForm.customerManagerName = this.userInfo.name
              this.customerManagerChange(this.addForm.customerManagerId)
            }
            this.businessTypeChange(this.addForm.businessType)
            this.addForm.qy = [this.addForm.area1, this.addForm.area2, this.addForm.area3]
            this.addForm.qy2 = [this.addForm.area1, this.addForm.area2, this.addForm.area3].join('/')
            this.$refs.picker2.setValues(this.addForm.qy)
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    titleClick(item, index) {
      console.log(item, index)
      if (item === '案件中心') {
        this.cancel()
        this.titles = ['案件中心'] // 导航菜单
      }
    },
    popupShow() {
      this.popupShowState = true
    },
    // 区域更改
    qyChange(val) {
      if (val) {
        this.addForm.area1 = val[0]
        this.addForm.area2 = val[1]
        this.addForm.area3 = val[2]
        this.addForm.qy2 = val.join('/')
        this.$refs.picker2.setValues(this.addForm.qy)
      }
    },
    // 区域选择
    pickerConfirm(val, indexs) {
      this.addForm.qy = val
      this.addForm.qy2 = val.join('/')
      this.addForm.area1 = val[0]
      this.addForm.area2 = val[1]
      this.addForm.area3 = val[2]
      this.popupShowState = false
    },
    pickerCancel() {
      this.addForm.qy = []
      this.addForm.qy2 = ''
      this.addForm.area1 = ''
      this.addForm.area2 = ''
      this.addForm.area3 = ''
      this.popupShowState = false
    },
    // 业务类型修改
    businessTypeChange(val) {
      console.log(val)
      console.log(this.businessTypes)
      for (let i = 0; i < this.businessTypes.length; i++) {
        if (this.businessTypes[i].name === val) {
          this.addForm.businessTypeCode = this.businessTypes[i].code
        }
      }
    },
    // 客户经理选择变化
    customerManagerChange(val) {
      for (let i = 0; i < this.persons.length; i++) {
        if (this.persons[i].id === val) {
          this.addForm.customerManagerName = this.persons[i].name
        }
      }
      console.log(this.addForm)
    },
    // 负责人选择变化
    caseAccountantChange(val) {
      if (this.addForm.id) {
        console.log(val)
        const ids = []
        for (let i = 0; i < this.caseAccountants.length; i++) {
          ids.push(this.caseAccountants[i].uid)
        }
        // 获取 新增的数据
        const addItem = val.filter(item => {
          return ids.indexOf(item) < 0
        })
        console.log(addItem)
        if (addItem.length > 0) {
          let name = ''
          for (let i = 0; i < this.persons.length; i++) {
            if (this.persons[i].id === addItem[0]) {
              name = this.persons[i].name
            }
          }
          console.log(name)
          const param = {
            caseId: this.addForm.id,
            name: name,
            uid: addItem[0]
          }
          this.$post('/case/addAccountant', param).then(
            result => {
              if (result.status === 200) {
                this.queryAccountant()
                this.$refs.caseAccountant.blur()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        }
        // 获取 删除的数据
        const delItem = ids.filter(item => {
          return val.indexOf(item) < 0
        })
        if (delItem.length > 0) {
          this.delAccountant(delItem[0])
        }
        console.log(delItem)
        // console.log(val)
        // console.log(this.caseAccountants)
        // if (val.length < this.caseAccountants.length) {
        //   const ids = []
        //   for (let i = 0; i < this.caseAccountants.length; i++) {
        //     ids.push(this.caseAccountants[i].uid)
        //   }
        //   const arr = ids.filter(item => {
        //     return val.indexOf(item) < 0
        //   })
        //   this.delAccountant(arr[0])
        //   console.log(arr)
        //   return false // 删除操作
        // } else {
        //   const ids = []
        //   for (let i = 0; i < this.caseAccountants.length; i++) {
        //     ids.push(this.caseAccountants[i].uid)
        //   }
        //   const arr = val.filter(item => {
        //     return ids.indexOf(item) < 0
        //   })
        //   let name = ''
        //   for (let i = 0; i < this.persons.length; i++) {
        //     if (this.persons[i].id === arr[0]) {
        //       name = this.persons[i].name
        //     }
        //   }
        //   console.log(name)
        //   const param = {
        //     caseId: this.addForm.id,
        //     name: name,
        //     uid: arr[0]
        //   }
        //   this.$post('/case/addAccountant', param).then(
        //     result => {
        //       if (result.status === 200) {
        //         this.queryAccountant()
        //         this.$refs.caseAccountant.blur()
        //         this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
        //       } else {
        //         this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
        //       }
        //     },
        //     error => {
        //       this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        //     }
        //   )
        //   console.log(arr)
      } else {
        const caseAccountants = []
        for (let i = 0; i < this.persons.length; i++) {
          for (let j = 0; j < val.length; j++) {
            if (this.persons[i].id === val[j]) {
              caseAccountants.push({
                uid: this.persons[i].id,
                name: this.persons[i].name
              })
            }
          }
        }
        this.caseAccountants = caseAccountants
      }
      setTimeout(() => {
        this.$refs.caseAccountant.blur()
      }, 50)
    },
    // 删除负责人
    delAccountant(val) {
      let id = ''
      for (let i = 0; i < this.caseAccountants.length; i++) {
        if (val === this.caseAccountants[i].uid) {
          id = this.caseAccountants[i].id
        }
      }
      const param = {
        id: id
      }
      this.$get('/case/deleteAccountant', param).then(
        result => {
          if (result.status === 200) {
            this.queryAccountant()
            this.$refs.caseAccountant.blur()
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 变更项选择变化
    caseChangeChange(val) {
      if (this.addForm.id) {
        console.log(val)
        console.log(this.caseChanges)
        if (val.length < this.caseChanges.length) {
          const names = []
          for (let i = 0; i < this.caseChanges.length; i++) {
            names.push(this.caseChanges[i].name)
          }
          const arr = names.filter(item => {
            return val.indexOf(item) < 0
          })
          this.delCaseChange2(arr[0])
          console.log(arr)
          return false // 删除操作
        } else {
          const names = []
          for (let i = 0; i < this.caseChanges.length; i++) {
            names.push(this.caseChanges[i].name)
          }
          const arr = val.filter(item => {
            return names.indexOf(item) < 0
          })
          console.log(arr)
          let name = ''
          for (let i = 0; i < this.changes.length; i++) {
            if (this.changes[i].name === arr[0]) {
              name = this.changes[i].name
            }
          }
          console.log(name)
          const param = {
            caseId: this.addForm.id,
            name: name,
            code: name
          }
          this.$post('/case/addChange', param).then(
            result => {
              if (result.status === 200) {
                this.queryChange()
                this.$refs.caseChange.blur()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
          console.log(arr)
        }
      } else {
        const caseChanges = []
        for (let i = 0; i < this.changes.length; i++) {
          for (let j = 0; j < val.length; j++) {
            if (this.changes[i].name === val[j]) {
              caseChanges.push({
                code: this.changes[i].code,
                name: this.changes[i].name
              })
            }
          }
        }
        this.caseChanges = caseChanges
      }
      setTimeout(() => {
        this.$refs.caseChange.blur()
      }, 50)
    },
    // 删除变更项
    delCaseChange2(val) {
      let id = ''
      for (let i = 0; i < this.caseChanges.length; i++) {
        if (val === this.caseChanges[i].name) {
          id = this.caseChanges[i].id
        }
      }
      const param = {
        id: id
      }
      this.$get('/case/deleteChange', param).then(
        result => {
          if (result.status === 200) {
            this.queryChange()
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    /**
     * 查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changes = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.circles = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
              if (this.addForm.businessType) {
                this.businessTypeChange(this.addForm.businessType)
              }
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询公司（客户）
    queryCustomerByCid() {
      const param = {
        cid: this.userInfo.cid
      }
      this.$get('/case/queryCustomerIdNameList', param).then(
        // this.$get('/customer/queryCustomerByCid', param).then(
        result => {
          if (result.status === 200) {
            this.customers = result.data
          } else {
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    },
    // 获取所有员工
    queryUserIdName() {
      const param = {}
      this.$get('/user/queryUserIdName', param).then(
        result => {
          if (result.status === 200) {
            this.persons = result.data
            if (!this.addForm.customerManagerId || !this.addForm.customerManagerName) {
              this.addForm.customerManagerId = this.userInfo.id
              this.addForm.customerManagerName = this.userInfo.name
              this.customerManagerChange(this.addForm.customerManagerId)
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询股东
    queryShareholder() {
      const param = {
        caseId: this.addForm.id
      }
      this.$get('case/queryShareholder', param).then(
        result => {
          if (result.status === 200) {
            this.caseShareholders = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询案件联系人
    queryContact() {
      const param = {
        caseId: this.addForm.id
      }
      this.$get('case/queryContact', param).then(
        result => {
          if (result.status === 200) {
            this.caseContacts = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询负责人
    queryAccountant() {
      const param = {
        caseId: this.addForm.id
      }
      this.$get('case/queryAccountant', param).then(
        result => {
          if (result.status === 200) {
            this.caseAccountants = result.data
            this.addForm.caseAccountant = []
            for (let i = 0; i < this.caseAccountants.length; i++) {
              this.addForm.caseAccountant.push(this.caseAccountants[i].uid)
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询变更项
    queryChange() {
      const param = {
        caseId: this.addForm.id
      }
      this.$get('case/queryChange', param).then(
        result => {
          if (result.status === 200) {
            this.caseChanges = result.data
            this.addForm.caseChange = []
            for (let i = 0; i < this.caseChanges.length; i++) {
              this.addForm.caseChange.push(this.caseChanges[i].name)
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 每页条数切换
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.queryProgress()
    },
    // 页码切换
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.queryProgress()
    },
    // 查询图片
    queryPic() {
      const param = {
        oid: this.addForm.id,
        caseId: this.addForm.id
      }
      this.$get('/pic/queryCasePic', param).then(
        result => {
          if (result.status === 200) {
            this.pics = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询文件
    queryFile() {
      const param = {
        oid: this.addForm.id,
        caseId: this.addForm.id
      }
      this.$get('/file/queryCaseFile', param).then(
        result => {
          if (result.status === 200) {
            this.files = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 新增股东
    addCaseShareholder() {
      this.caseShareholderForm = {
        name: '',
        shareProportion: '',
        idcardEmblem: '', // 股东身份证国徽面
        idcardHead: ''
      }
      this.caseShareholders.push({
        state: 'add',
        name: '',
        idcardEmblem: '',
        idcardHead: ''
      })
    },
    // 股东保存
    caseShareholderFormSave(index, data) {
      if (!this.caseShareholderForm.name) {
        return this.$toast('请填写股东！')
      }
      if (!this.caseShareholderForm.shareProportion) {
        return this.$toast('请填写占股比例！')
      }
      if (this.caseShareholderForm.shareProportion > 100 || this.caseShareholderForm.shareProportion < 0) {
        return this.$toast('占股比例不得大于100，不得小于0！')
      }
      // if (!this.caseShareholderForm.idcardEmblem) {
      //   return this.$toast('请上传股东身份证国徽面！')
      // }
      if (!this.caseShareholderForm.idcardHead) {
        return this.$toast('请上传股东身份证头像面！')
      }
      if (this.addForm.id) {
        const param = {
          caseId: this.addForm.id,
          name: this.caseShareholderForm.name,
          shareProportion: this.caseShareholderForm.shareProportion,
          idcardEmblem: this.caseShareholderForm.idcardEmblem,
          idcardHead: this.caseShareholderForm.idcardHead
        }
        this.$post('/case/addShareholder', param).then(
          result => {
            if (result.status === 200) {
              this.queryShareholder()
              this.caseShareholders[index].state = ''
              this.caseShareholders = this.$common.jsonStr(this.caseShareholders)
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      } else {
        this.caseShareholders[index] = this.caseShareholderForm
        this.caseShareholders[index].state = ''
        this.caseShareholders = this.$common.jsonStr(this.caseShareholders)
      }
    },
    // 删除股东
    delCaseShareholder(index, data) {
      if (data.id) {
        const param = {
          id: data.id
        }
        this.$root.$children[0].vueConfirm({ message: '确定要删除股东？', type: 'warning' }, () => {
          this.$get('/case/deleteShareholder', param).then(
            result => {
              if (result.status === 200 || result.status === 0) {
                this.queryShareholder()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        })
      } else {
        this.caseShareholders.splice(index, 1)
      }
    },
    // 新增案件联系人点击
    addContact() {
      this.caseContacts.push({
        state: 'add',
        name: '',
        phone: ''
      })
    },
    // 案件联系人保存
    caseContactFormSave(index, data) {
      if (!data.name) {
        return this.$toast('请填写案件联系人！')
      }
      if (!data.phone) {
        return this.$toast('请填写联系电话！')
      }
      if (this.addForm.id) {
        const param = {
          caseId: this.addForm.id,
          name: data.name,
          phone: data.phone
        }
        this.$post('/case/addContact', param).then(
          result => {
            if (result.status === 200) {
              this.queryContact()
              this.caseContacts[index].state = ''
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      } else {
        this.caseContacts[index].state = ''
      }
    },
    // 删除案件联系人
    delContact(index, data) {
      if (data.id) {
        const param = {
          id: data.id
        }
        this.$root.$children[0].vueConfirm({ message: '确定要删除案件联系人？', type: 'warning' }, () => {
          this.$get('/case/deleteContact', param).then(
            result => {
              if (result.status === 200 || result.status === 0) {
                this.queryContact()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        })
      } else {
        this.caseContacts.splice(index, 1)
      }
    },
    // 新增变更项点击
    addCaseChange() {
      this.web = 'caseChange'
      setTimeout(() => {
        this.$refs.caseChangeForm.clearValidate()
      }, 100)
    },
    // 删除变更项
    delCaseChange(index, data) {
      if (data.id) {
        const param = {
          id: data.id
        }
        this.$root.$children[0].vueConfirm({ message: '确定要删除案件联系人？', type: 'warning' }, () => {
          this.$get('/case/deleteChange', param).then(
            result => {
              if (result.status === 200) {
                this.queryCaseChange()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        })
      } else {
        this.caseChanges.splice(index, 1)
      }
    },
    // 新增变更项保存
    caseChangeFormSave(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.addForm.id) {
            const param = {
              caseId: this.addForm.id,
              name: this.caseChangeForm.name,
              phone: this.caseChangeForm.phone
            }
            this.$post('/case/addChange', param).then(
              result => {
                if (result.status === 200) {
                  this.$refs[name].resetFields()
                  this.cancel('detail')
                  this.queryChange()
                  this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                } else {
                  this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
                }
              },
              error => {
                this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
              }
            )
          } else {
            this.caseChanges.push({
              name: this.caseChangeForm.name,
              phone: this.caseChangeForm.phone
            })
            this.$refs[name].resetFields()
            this.cancel('detail')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 查询进展
    queryProgress() {
      const param = {
        caseId: this.addForm.id,
        page: this.currentPage,
        limit: this.pageSize
      }
      this.$post('case/queryProgress', param).then(
        result => {
          if (result.status === 200) {
            this.total = result.count
            this.progresss = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 新增进展点击
    addProgress() {
      this.progresss.push({
        content: '',
        operator: this.userInfo.id,
        progressTime: this.$common.timeFormat(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        state: 'add'
      })
    },
    // 新增进展保存
    progressFormSave(index, data) {
      if (!data.content) {
        return this.$toast('请填写进展！')
      }
      if (this.addForm.id) {
        const param = {
          caseId: this.addForm.id,
          operator: this.userInfo.id,
          content: data.content,
          progressTime: this.$common.timeFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
        }
        this.$post('/case/addProgress', param).then(
          result => {
            if (result.status === 200) {
              this.progresss[index].state = ''
              this.queryProgress()
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      } else {
        this.progresss[index].state = ''
      }
    },
    delProgress(index, data) {
      this.progresss.splice(index, 1)
    },
    webShow(name) {
      this.web = name
      if (name === 'treasurer') {
        this.treasurerForm.treasurer = this.addForm.treasurer
        this.treasurerForm.treasurerIdcardEmblem = this.addForm.treasurerIdcardEmblem
        this.treasurerForm.treasurerIdcardHead = this.addForm.treasurerIdcardHead
      }
      if (name === 'supervisor') {
        this.supervisorForm.supervisor = this.addForm.supervisor
        this.supervisorForm.supervisorIdcardEmblem = this.addForm.supervisorIdcardEmblem
        this.supervisorForm.supervisorIdcardHead = this.addForm.supervisorIdcardHead
      }
      if (name === 'legalPerson') {
        this.legalPersonForm.legalPerson = this.addForm.legalPerson
        this.legalPersonForm.legalPersonIdcardEmblem = this.addForm.legalPersonIdcardEmblem
        this.legalPersonForm.legalPersonIdcardHead = this.addForm.legalPersonIdcardHead
      }
    },
    // 财务负责人 填写完成
    treasurerFormSave(name) {
      this.addForm.treasurer = this.treasurerForm.treasurer
      this.addForm.treasurerIdcardEmblem = this.treasurerForm.treasurerIdcardEmblem
      this.addForm.treasurerIdcardHead = this.treasurerForm.treasurerIdcardHead
      this.$refs[name].resetFields()
      this.cancel('detail')
    },
    // 监事 填写完成
    supervisorFormSave(name) {
      this.addForm.supervisor = this.supervisorForm.supervisor
      this.addForm.supervisorIdcardEmblem = this.supervisorForm.supervisorIdcardEmblem
      this.addForm.supervisorIdcardHead = this.supervisorForm.supervisorIdcardHead
      this.$refs[name].resetFields()
      this.cancel('detail')
    },
    // 法人 填写完成
    legalPersonFormSave(name) {
      this.addForm.legalPerson = this.legalPersonForm.legalPerson
      this.addForm.legalPersonIdcardEmblem = this.legalPersonForm.legalPersonIdcardEmblem
      this.addForm.legalPersonIdcardHead = this.legalPersonForm.legalPersonIdcardHead
      this.$refs[name].resetFields()
      this.cancel('detail')
    },
    // 图片预览
    picRead(e) {
      if (!this.addForm.picName) {
        this.$refs[e.target.name].value = ''
        return this.$root.$children[0].vueAlert({ message: '请填写图片名称', type: 'error' })
      }
      const _this = this
      var files = e.target.files[0]
      console.log(e)
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      const reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function() {
        _this[e.target.name] = {
          src: this.result,
          file: e.target.files[0]
        }
        _this.addForm[e.target.name] = e.target.files[0]
        _this.$refs[e.target.name].value = ''
        _this.uploadPic()
      }
    },
    // 图片预览
    picReadUpload(e, formName) {
      const names = {
        idcardEmblem: '股东身份证国徽面',
        idcardHead: '股东身份证头像面',
        supervisorIdcardEmblem: '监事身份证国徽面', // 监事身份证国徽面
        supervisorIdcardHead: '监事身份证头像面', // 监事身份证头像面
        treasurerIdcardEmblem: '财务负责人身份证国徽面', // 财务负责人身份证国徽面
        treasurerIdcardHead: '财务负责人身份证头像面', // 财务负责人身份证头像面
        legalPersonIdcardEmblem: '法人身份证国徽面', // 法人身份证国徽面
        legalPersonIdcardHead: '法人身份证头像面' // 法人身份证头像面
      }
      var files = e.target.files[0]
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      const reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = () => {
        const pic = e.target.files[0]
        this.$refs[e.target.name].value = ''
        const param = new FormData()
        param.append('oid', 0)
        param.append('name', names[e.target.name])
        param.append('pic', pic)
        this.$formData('/pic/upload', param).then(
          result => {
            if (result.status === 200) {
              const form = this[formName]
              form[e.target.name] = result.data.url
              this[formName] = form
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      }
    },
    // 图片预览
    fileRead(e) {
      if (!this.addForm.fileName) {
        this.$refs[e.target.name].value = ''
        return this.$root.$children[0].vueAlert({ message: '请填写文件名称', type: 'error' })
      }
      var files = e.target.files[0]
      console.log(files)
      console.log(files.name)
      console.log(e.target.name)
      this[e.target.name] = {
        src: files.name,
        file: e.target.files[0]
      }
      this.addForm[e.target.name] = e.target.files[0]
      this.$refs[e.target.name].value = ''
      this.uploadFile()
    },
    uploadFile() {
      const param = new FormData()
      if (!this.addForm.fileName) {
        return this.$root.$children[0].vueAlert({ message: '请填写文件名称', type: 'error' })
      }
      if (!this.addForm.picJdcmp2) {
        return this.$root.$children[0].vueAlert({ message: '请选择文件', type: 'error' })
      }
      param.append('oid', this.addForm.id)
      param.append('caseId', this.addForm.id)
      param.append('name', this.addForm.fileName)
      param.append('file', this.addForm.picJdcmp2)
      this.$formData('/file/upload', param).then(
        result => {
          if (result.status === 200) {
            this.picJdcmp2 = { src: '', file: '', name: '文件' }
            this.addForm.fileName = ''
            this.addForm.picJdcmp2 = ''
            this.queryFile()
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 删除文件
    delFile(data) {
      const param = {
        id: data.id
      }
      this.$root.$children[0].vueConfirm({ message: '确定要删除文件？', type: 'warning' }, () => {
        this.$get('/file/delete', param).then(
          result => {
            if (result.status === 200) {
              this.queryFile()
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      })
    },
    uploadPic() {
      const param = new FormData()
      if (!this.addForm.picName) {
        return this.$root.$children[0].vueAlert({ message: '请填写图片名称', type: 'error' })
      }
      if (!this.addForm.picJdcmp) {
        return this.$root.$children[0].vueAlert({ message: '请选择图片', type: 'error' })
      }
      param.append('oid', this.addForm.id)
      param.append('caseId', this.addForm.id)
      param.append('name', this.addForm.picName)
      param.append('pic', this.addForm.picJdcmp)
      this.$formData('/pic/upload', param).then(
        result => {
          if (result.status === 200) {
            this.picJdcmp = { src: '', file: '', name: '图片' }
            this.addForm.picName = ''
            this.addForm.picJdcmp = ''
            this.queryPic()
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 删除文件
    delPic(data) {
      console.log(data)
      const param = {
        id: data.id
      }
      this.$root.$children[0].vueConfirm({ message: '确定要删除图片？', type: 'warning' }, () => {
        this.$get('/pic/delete', param).then(
          result => {
            if (result.status === 200) {
              this.queryPic()
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      })
    },
    downloadIamge(imgsrc, name) {
      if (window.location.host !== 'wechat.suzhougs.com') {
        imgsrc = '/imgProxy/' + imgsrc
      }
      // 下载图片地址和图片名
      const image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function() {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        const url = canvas.toDataURL('image/jpeg') // 得到图片的base64编码数据
        const a = document.createElement('a') // 生成一个a元素
        const event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.target = '_blank'
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    // 图片选择
    picSelectionChange(val) {
      this.picSelection = val
      console.log(this.picSelection)
    },
    // 图片选择下载
    picSelectionDownload() {
      if (this.picSelection.length <= 0) {
        return this.$root.$children[0].vueAlert({ message: '请选择图片', type: 'error' })
      }
      for (let i = 0; i < this.picSelection.length; i++) {
        this.downloadIamge(this.picSelection[i].url, this.picSelection[i].name)
      }
    },
    // 文件选择
    fileSelectionChange(val) {
      this.fileSelection = val
      console.log(this.fileSelection)
    },
    // 文件选择下载
    fileSelectionDownload() {
      if (this.fileSelection.length <= 0) {
        return this.$root.$children[0].vueAlert({ message: '请选择文件', type: 'error' })
      }
      for (let i = 0; i < this.fileSelection.length; i++) {
        if (/\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)$/.test(this.fileSelection[i].url)) {
          this.downloadIamge(this.fileSelection[i].url, this.fileSelection[i].name)
        } else {
          const a = document.createElement('a') // 生成一个a元素
          const event = new MouseEvent('click') // 创建一个单击事件
          a.download = this.fileSelection[i].name // 设置图片名称
          a.href = this.fileSelection[i].url // 将生成的URL设置为a.href属性
          a.target = '_blank'
          a.dispatchEvent(event) // 触发a的单击事件
          // window.open(this.fileSelection[i].url, 'target')
        }
      }
    },
    // 股东图片选择
    shareholderSelectionChange(val) {
      this.shareholderSelection = val
      console.log(this.shareholderSelection)
    },
    // 股东选择下载
    shareholderSelectionDownload() {
      if (this.shareholderSelection.length <= 0) {
        return this.$root.$children[0].vueAlert({ message: '请选择股东', type: 'error' })
      }
      for (let i = 0; i < this.shareholderSelection.length; i++) {
        this.downloadIamge(
          this.shareholderSelection[i].idcardEmblem,
          '股东身份证国徽面-' + this.shareholderSelection[i].name
        )
        this.downloadIamge(
          this.shareholderSelection[i].idcardHead,
          '股东身份证头像面-' + this.shareholderSelection[i].name
        )
      }
    },
    // 新增收费项目
    addPay() {
      this.drawer = true
      this.payRecord = {
        caseId: '', // 案件id
        customerId: '', // 客户id
        customerName: this.addForm.companyName, // 客户名称
        payProject: '', // 收费项目名称
        amount: '', // 总金额
        realAmount: '', // 实收金额
        discount: 10, // 折扣
        finalPayment: '', // 尾款
        payPeriodStart: '', // 计费周期始
        payPeriodEnd: '', // 计费周期止
        payTime: [],
        remark: ''
      }
      this.$nextTick(() => {
        this.$refs.payRecord.clearValidate()
      })
    },
    payPeriodStartChange(val) {
      if (this.payRecord.payPeriodEnd && val > this.payRecord.payPeriodEnd) {
        this.payRecord.payPeriodStart = this.payRecord.payPeriodEnd
        return this.$message.error('请选择开始时间不能大于结束时间！')
      }
      console.log(val)
      if (val && this.payRecord.payPeriodEnd) {
        this.payRecord.payTime = [this.payRecord.payPeriodStart, this.payRecord.payPeriodEnd]
      }
    },
    payPeriodEndChange(val) {
      console.log(val)
      if (!this.payRecord.payPeriodStart) {
        this.payRecord.payPeriodEnd = ''
        return this.$message.error('请选择开始时间！')
      }
      if (val < this.payRecord.payPeriodStart) {
        this.payRecord.payPeriodEnd = this.payRecord.payPeriodStart
        return this.$message.error('结束时间不能小于开始时间！')
      }
      if (val && this.payRecord.payPeriodStart) {
        this.payRecord.payTime = [this.payRecord.payPeriodStart, this.payRecord.payPeriodEnd]
      }
    },
    addPaySave() {
      if (!this.payRecord.payTime[0]) {
        this.payRecord.payPeriodStart = ''
        this.payRecord.payPeriodEnd = ''
      } else {
        this.payRecord.payPeriodStart = this.$common.timeFormat(
          new Date(this.payRecord.payTime[0].replace(/\-/g, '/')),
          'yyyy-MM-dd 00:00:00'
        )
        this.payRecord.payPeriodEnd = this.$common.timeFormat(
          new Date(this.payRecord.payTime[1].replace(/\-/g, '/')),
          'yyyy-MM-dd 00:00:00'
        )
      }
      this.$refs.payRecord.validate(valid => {
        if (valid) {
          const param = {
            caseId: this.addForm.id, // 案件id
            // customerId: this.addForm.id, // 客户id
            customerName: this.payRecord.customerName, // 客户名称
            payProject: this.payRecord.payProject, // 收费项目名称
            amount: this.payRecord.amount, // 总金额
            realAmount: this.payRecord.realAmount, // 实收金额
            discount: this.payRecord.discount, // 折扣
            finalPayment: this.payRecord.finalPayment, // 尾款
            payPeriodStart: this.payRecord.payPeriodStart, // 计费周期始
            payPeriodEnd: this.payRecord.payPeriodEnd, // 计费周期止
            operName: this.userInfo.name,
            operId: this.userInfo.id,
            remark: this.payRecord.remark
          }
          this.$post('/financial/addPayRecord', param).then(
            result => {
              if (result.status === 200) {
                this.drawer = false
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log(valid)
        }
      })
    },
    // 新增保存
    addSave(name) {
      console.log(this.$common.jsonStr(this.addForm))
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log('通过')
          const param = {
            companyName: this.addForm.companyName, // 公司名称
            companyName1: this.addForm.companyName1 || '', // 公司名称
            companyName2: this.addForm.companyName2 || '', // 公司名称
            companyName3: this.addForm.companyName3 || '', // 公司名称
            companyName4: this.addForm.companyName4 || '', // 公司名称
            companyName5: this.addForm.companyName5 || '', // 公司名称
            customerManagerId: this.addForm.customerManagerId, // 客户经理id
            customerManagerName: this.addForm.customerManagerName, // 客户经理姓名
            area1: this.addForm.area1,
            area2: this.addForm.area2,
            area3: this.addForm.area3,
            address: this.addForm.address, // 地址
            businessType: this.addForm.businessType, // 业务类型
            caseType: this.addForm.caseType, // 案件类型
            natureOfBusiness: this.addForm.natureOfBusiness, // 经营范围
            registeredCapital: this.addForm.registeredCapital, // 注册资金
            remark: this.addForm.remark, // 业务说明（备注）
            taxNature: this.addForm.taxNature, // 纳税性质
            isBookkeeping: this.addForm.isBookkeeping, // 是否代理记账
            advancePayment: this.addForm.advancePayment, // 预付款
            finalPayment: this.addForm.finalPayment, // 尾款
            qualification: this.addForm.qualification, // 项目名称
            deadline: this.addForm.deadline, // 项目名称

            supervisor: this.addForm.supervisor, // 监事
            supervisorIdcardEmblem: this.addForm.supervisorIdcardEmblem, // 监事身份证国徽面
            supervisorIdcardHead: this.addForm.supervisorIdcardHead, // 监事身份证头像面
            treasurer: this.addForm.treasurer, // 财务负责人
            treasurerIdcardEmblem: this.addForm.treasurerIdcardEmblem, // 财务负责人身份证国徽面
            treasurerIdcardHead: this.addForm.treasurerIdcardHead, // 财务负责人身份证头像面
            legalPerson: this.addForm.legalPerson, // 法人
            legalPersonIdcardEmblem: this.addForm.legalPersonIdcardEmblem, // 法人身份证国徽面
            legalPersonIdcardHead: this.addForm.legalPersonIdcardHead, // 法人身份证头像面

            caseAccountants: this.caseAccountants, // 负责人数组
            caseChanges: this.caseChanges, // 变更项
            caseContacts: this.caseContacts, // 案件联系人
            caseShareholders: this.caseShareholders // 股东
          }
          this.$post('/case/add', param).then(
            result => {
              if (result.status === 200) {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                // this.cancel()
                this.$router.push({
                  name: 'CaseDetail',
                  params: {
                    id: result.data.id,
                    webState: 'edit'
                  }
                })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑保存
    editSave(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log('通过')
          const param = {
            id: this.addForm.id,
            caseId: this.addForm.id,
            companyName: this.addForm.companyName, // 公司名称
            companyName1: this.addForm.companyName1, // 公司名称
            companyName2: this.addForm.companyName2, // 公司名称
            companyName3: this.addForm.companyName3, // 公司名称
            companyName4: this.addForm.companyName4, // 公司名称
            companyName5: this.addForm.companyName5, // 公司名称
            customerManagerId: this.addForm.customerManagerId, // 客户经理id
            customerManagerName: this.addForm.customerManagerName, // 客户经理姓名
            area1: this.addForm.area1,
            area2: this.addForm.area2,
            area3: this.addForm.area3,
            address: this.addForm.address, // 地址
            businessType: this.addForm.businessType, // 业务类型
            caseType: this.addForm.caseType, // 案件类型
            natureOfBusiness: this.addForm.natureOfBusiness, // 经营范围
            registeredCapital: this.addForm.registeredCapital, // 注册资金
            remark: this.addForm.remark, // 业务说明（备注）
            taxNature: this.addForm.taxNature, // 纳税性质
            isBookkeeping: this.addForm.isBookkeeping, // 是否代理记账
            advancePayment: this.addForm.advancePayment, // 预付款
            finalPayment: this.addForm.finalPayment, // 尾款
            qualification: this.addForm.qualification, // 项目名称
            deadline: this.addForm.deadline, // 截止日期
            state: this.addForm.state, // 项目名称

            supervisor: this.addForm.supervisor, // 监事
            supervisorIdcardEmblem: this.addForm.supervisorIdcardEmblem, // 监事身份证国徽面
            supervisorIdcardHead: this.addForm.supervisorIdcardHead, // 监事身份证头像面
            treasurer: this.addForm.treasurer, // 财务负责人
            treasurerIdcardEmblem: this.addForm.treasurerIdcardEmblem, // 财务负责人身份证国徽面
            treasurerIdcardHead: this.addForm.treasurerIdcardHead, // 财务负责人身份证头像面
            legalPerson: this.addForm.legalPerson, // 法人
            legalPersonIdcardEmblem: this.addForm.legalPersonIdcardEmblem, // 法人身份证国徽面
            legalPersonIdcardHead: this.addForm.legalPersonIdcardHead // 法人身份证头像面
          }
          this.$post('/case/update', param).then(
            result => {
              if (result.status === 200) {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                this.queryDetail()
                // this.cancel()
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancel(state) {
      this.$router.push({
        name: 'Case'
      })
      this.picJdcmp = { src: '', file: '', name: '图片' }
      this.picJdcmp2 = { src: '', file: '', name: '文件' }
      this.$refs.addForm.resetFields()
    },
    onResize() {
      const bodyWidth = document.body.getBoundingClientRect().width
      if (bodyWidth <= 768) {
        this.showState = 'phone'
      } else {
        this.showState = 'pc'
      }
    },
    // 一键转客户
    caseToCustomer() {
      const param = {
        id: this.addForm.id
      }
      this.$root.$children[0].vueConfirm({ message: '是否一键转客户', type: 'warning' }, () => {
        this.$get('/case/caseToCustomer', param).then(
          result => {
            if (result.status === 200) {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      })
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
      console.log(this.userInfo.permissions, this.userInfo.permissions.indexOf('case:updateDeadline') < 0)
      this.deadlineDisabled = this.userInfo.permissions && this.userInfo.permissions.indexOf('case:updateDeadline') < 0
    } else {
      var broser = window.navigator.userAgent.toLowerCase()
      // 通过正则表达式匹配broser 中是否含有MicroMessenger字符串
      if (broser.match(/MicroMessenger/i) === 'micromessenger') {
        window.location.href = 'http://17l.link/dist/?id=1&targetName=Case&wechatLogin=true&state=123'
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
      return
    }
    this.web = this.$route.params.webState
    this.addForm.id = this.$route.params.id
    this.addForm.qy = [this.userInfo.area1 || '', this.userInfo.area2 || '', this.userInfo.area3 || '']
    this.addForm.area1 = this.userInfo.area1
    this.addForm.area2 = this.userInfo.area2
    this.addForm.area3 = this.userInfo.area3
    this.addForm.qy2 = [this.userInfo.area1 || '', this.userInfo.area2 || '', this.userInfo.area3 || ''].join('/')
    this.$nextTick(() => {
      this.$refs.picker2.setValues(this.addForm.qy)
    })
    console.log(this.addForm.id)
    const titleName = {
      add: '新增案件',
      edit: '编辑案件',
      detail: '案件详情'
    }
    this.titles = ['案件中心', titleName[this.web]]
    this.queryCode(0)
    this.queryCode(1)
    this.queryCode(3)
    this.queryCode(4)
    this.queryCode(5)
    this.queryUserIdName()
    this.queryCustomerByCid()
    if (this.addForm.id) {
      this.queryDetail()
      if (this.userInfo.permissions.indexOf('case:queryShareholder') >= 0) {
        this.queryShareholder() // 查询股东
      }
      if (this.userInfo.permissions.indexOf('case:queryContact') >= 0) {
        this.queryContact() // 查询案件联系人
      }
      if (this.userInfo.permissions.indexOf('case:queryAccountant') >= 0) {
        this.queryAccountant() // 查询负责人
      }
      if (this.userInfo.permissions.indexOf('case:queryChange') >= 0) {
        this.queryChange() // 查询变更项
      }
      if (this.userInfo.permissions.indexOf('case:queryProgress') >= 0) {
        this.queryProgress() // 查询进展
      }
      this.queryPic() // 查询图片
      this.queryFile() // 查询文件
    }
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="less" scoped>
.edit-page,
.main-page {
  height: 100%;
}
.colspan {
  display: flex;
  span {
    flex: 1;
  }
}
.el-form-item {
  margin-bottom: 12px;
  /deep/.el-form-item__error {
    top: 85%;
  }
  /deep/.el-textarea + .el-form-item__error {
    top: 100%;
  }
}
.img-box {
  position: relative;
  display: inline-flex;
  width: 7vh;
  height: 5vh;
  margin-right: 5vh;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 5vh;
    min-height: 2vh;
  }
  .upload {
    display: inline-flex;
    position: relative;
    width: 5vh;
    height: 5vh;
    // color: #ccc;
    // border: 2px solid #ccc;
    line-height: 0;
    align-items: center;
    justify-content: center;
    vertical-align: text-bottom;
    background: url('../../../assets/img/icon-upload.png') no-repeat 100% 100%;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 5vh;
      height: 5vh;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
  .upload-btn {
    display: inline-flex;
    position: relative;
    align-items: center;
    justify-content: center;
    vertical-align: text-bottom;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
  .mask {
    display: flex;
    position: relative;
    width: 10vh;
    height: 4vh;
    line-height: 4vh;
    color: #ccc;
    background: #67c23a;
    font-size: 3rem;
    border-radius: 0.5vw;
    line-height: 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .mask-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
      z-index: 1000;
    }
    .el-icon-plus {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
    .text {
      font-size: 1rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
  }
}
.img-box2 {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 10vh;
    min-height: 10vh;
  }
  .upload {
    display: inline-flex;
    position: relative;
    align-items: center;
    justify-content: center;
    vertical-align: text-bottom;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
  .mask {
    display: flex;
    position: relative;
    width: 10vh;
    height: 10vh;
    color: #ccc;
    background: rgba(0, 0, 0, 0.5);
    font-size: 2.15rem;
    line-height: 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .mask-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
      z-index: 1000;
    }
    .el-icon-plus {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
    .text {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
  }
}
.drawer-box {
  max-height: 100vh;
  overflow: auto;
  padding: 0 8px;
}
</style>
